/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import moment from 'moment';

// @material-ui/core components
import { makeStyles } from '@material-ui/styles';


import { useSelector } from 'react-redux';

import _ from 'lodash';
import { getNQ } from 'constants/enbrain_games';

import {
  dangerColor,
  infoColor,
  grayColor,
  hexToRgb
} from "assets/jss/material-dashboard-pro-react.jsx";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";

import enbrainWhiteLogo from "assets/img/enbrain_white.png";

import { Radar, HorizontalBar, Line } from "react-chartjs-2";

import BigCalendar from "react-big-calendar";
import 'react-big-calendar/lib/css/react-big-calendar.css'
import { Container, Row, Col } from "reactstrap";
import ProfileForDashboard from "components/Profile/ProfileForDashboard";
import { useFirestoreConnect } from "react-redux-firebase";
import CardSection from "./CardSection";
import NotEnoughData from "./NotEnoughData";

const localizer = BigCalendar.momentLocalizer(moment);

const useStyles = makeStyles({
  ...dashboardStyle,
  profileItem: {
    marginBottom: 10
  }
})

var Chartist = require("chartist");

var delays = 80,
  durations = 500;

function DashboardForPerson({ uid: _uid, org_id: _org_id, location, history }) {

  const uid = _uid || location?.state?.uid;
  const org_id = _org_id || location?.state?.org_id;


  useEffect(() => {
    if (!uid) {
      alert('사용자를 선택해주세요.')
      return history.goBack();
    }
    if (!org_id) {
      alert('사용자의 기관을 선택해주세요.');
      return history.goBack();
    }

    return () => {
      // cleanup
    }
  }, []);

  const classes = useStyles();

  useFirestoreConnect([
    `statistics/${uid}`,
    `users/${uid}`,
    `roles/${uid}`,
    `orgs/${org_id}`,
  ]);

  const statisticsData = useSelector(({ firestore: { data } }) => data.statistics && data.statistics[uid]);
  const userData = useSelector(({ firestore: { data } }) => data.users && data.users[uid]);
  const roleData = useSelector(({ firestore: { data } }) => data.roles && data.roles[uid]);
  const orgData = useSelector(({ firestore: { data } }) => data.orgs && data.orgs[org_id]);

  console.log('통계데이터 = ', statisticsData);
  console.log('user 데이터 = ', userData);
  console.log('role 데이터 = ', roleData);
  console.log('org 데이터 = ', orgData);


  const { enbrainResult = [], testResult = [], stage = {} } = statisticsData || {};


  const commonOption = {
    options: {
      lineSmooth: Chartist.Interpolation.cardinal({
        tension: 0
      }),
      low: 0,
      high: 20, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
      chartPadding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      }
    },
    animation: {
      draw: function (data) {
        if (data.type === "line" || data.type === "area") {
          data.element.animate({
            d: {
              begin: 600,
              dur: 700,
              from: data.path
                .clone()
                .scale(1, 0)
                .translate(0, data.chartRect.height())
                .stringify(),
              to: data.path.clone().stringify(),
              easing: Chartist.Svg.Easing.easeOutQuint
            }
          });
        } else if (data.type === "point") {
          data.element.animate({
            opacity: {
              begin: (data.index + 1) * delays,
              dur: durations,
              from: 0,
              to: 1,
              easing: "ease"
            }
          });
        }
      }
    }
  }

  const events = enbrainResult
    .filter(item => item.count > 0)
    .map(item => ({
      title: '엔브레인 실행',
      allDay: true,
      start: new Date(item.date.value),
      end: new Date(item.date.value),
      color: "red"
    }))

  const enbrainGameHistory = {
    data: {
      labels: enbrainResult.map((obj, idx) => idx % 2 === 0 ? obj.date.value : ''),
      series: [
        enbrainResult.map(obj => obj.count)
      ]
    },
    ...commonOption
  };

  // const dimentiaTestHistory = {
  //   data: {
  //     labels: testResult
  //       .filter(result => result.game_id === '디멘시아')
  //       .map(obj => moment(obj.created_at.value).format('YYYY-MM-DD')),
  //     series: [
  //       testResult
  //         .filter(result => result.game_id === '디멘시아')
  //         .map(obj => obj.score)
  //     ]
  //   },
  //   ...commonOption
  // };

  // const depressTestHistory = {
  //   data: {
  //     labels: testResult
  //       .filter(result => result.game_id === '우울증')
  //       .map(obj => moment(obj.created_at.value).format('YYYY-MM-DD')),
  //     series: [
  //       testResult
  //         .filter(result => result.game_id === '우울증')
  //         .map(obj => obj.score)
  //     ]
  //   },
  //   ...commonOption
  // };

  // const stressTestHistory = {
  //   data: {
  //     labels: testResult
  //       .filter(result => result.game_id === '스트레스')
  //       .map(obj => moment(obj.created_at.value).format('YYYY-MM-DD')),
  //     series: [
  //       testResult
  //         .filter(result => result.game_id === '스트레스')
  //         .map(obj => obj.score)
  //     ]
  //   },
  //   ...commonOption
  // };

  const nq = getNQ(stage);
  const avgNQ = [28, 48, 40, 19, 96];

  const commonData = {
    fill: false,
    lineTension: 0.1,
    backgroundColor: 'rgba(75,192,192,0.4)',
    borderColor: 'rgba(75,192,192,1)',
    borderCapStyle: 'butt',
    borderDash: [],
    borderDashOffset: 0.0,
    borderJoinStyle: 'miter',
    pointBorderColor: 'rgba(75,192,192,1)',
    pointBackgroundColor: '#fff',
    pointBorderWidth: 1,
    pointHoverRadius: 5,
    pointHoverBackgroundColor: 'rgba(75,192,192,1)',
    pointHoverBorderColor: 'rgba(220,220,220,1)',
    pointHoverBorderWidth: 2,
    pointRadius: 1,
    pointHitRadius: 10,
  }

  const enbrainPlayTimesData = {
    labels: enbrainResult.map(item => item.date.value),
    datasets: [
      {
        ...commonData,
        label: '플래이 횟수',
        data: enbrainResult.map(item => item.count)
      }
    ]
  }

  const testResultData = (testName) => ({
    labels: testResult
      .filter(item => item.game_id === testName)
      .map(item => moment(item.created_at.value).format('YYYY-MM-DD')),
    datasets: [
      {
        ...commonData,
        label: '점수',
        data: testResult.filter(item => item.game_id === testName).map(item => item.score)
      }
    ]
  })

  return (uid && org_id)
    ? (
      <Container>
        <Row className='mb-3'>
          <Col>
            <ProfileForDashboard
              user={userData}
              role={roleData}
              org={orgData}
            />
          </Col>
        </Row>
        <Row className='mb-3'>
          <Col>
            <Row>
              <Col>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <div style={{
                    backgroundColor: dangerColor[0],
                    borderRadius: 10,
                    width: 20,
                    height: 20,
                    marginRight: "8px"
                  }}></div><span style={{ fontSize: '1.5em', fontWeight: 'bold' }}>엔브레인 - 두뇌활력 인지영역 결과</span>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className='mb-3'>
          <Col>
            <CardSection
              classes={classes}
              title='엔브레인 - 영역별 평균대비 능력'
              titleImage={enbrainWhiteLogo}
              legends={[
                { className: 'legendInfoBox', title: '점수' },
                { className: 'legendDangerBox', title: '평균' },
              ]}
            >
              <Radar
                data={{
                  labels: ['순발력', '판단력', '기억력', '사고력', '집중력'],
                  datasets: [
                    {
                      label: '점수',
                      backgroundColor: 'rgba(179,181,198,0.2)',
                      borderColor: infoColor[0],
                      pointBackgroundColor: 'rgba(179,181,198,1)',
                      pointBorderColor: '#fff',
                      pointHoverBackgroundColor: '#fff',
                      pointHoverBorderColor: 'rgba(179,181,198,1)',
                      data: nq
                    },
                    {
                      label: '평균',
                      backgroundColor: 'rgba(255,99,132,0.2)',
                      borderColor: dangerColor[0],
                      pointBackgroundColor: 'rgba(255,99,132,1)',
                      pointBorderColor: '#fff',
                      pointHoverBackgroundColor: '#fff',
                      pointHoverBorderColor: 'rgba(255,99,132,1)',
                      data: avgNQ
                    }
                  ],
                }}
                height={205}
                legend={{
                  display: false,
                }}
                options={{
                  scale: {
                    pointLabels: {
                      fontSize: 14
                    }
                  }
                }}
              />
              {
                _.sum(nq) === 0
                  ? <NotEnoughData />
                  : null
              }
            </CardSection>
          </Col>
          <Col>
            <CardSection
              classes={classes}
              title={'엔브레인 - NQ(Network Quotient)지수'}
              titleImage={enbrainWhiteLogo}
              legends={[
                { className: 'legendDangerBox', title: '점수' },
                { className: 'legendGrayBox', title: '평균' },
              ]}
            >
              <HorizontalBar
                data={{
                  labels: ['순발력', '판단력', '기억력', '사고력', '집중력'],
                  datasets: [
                    {
                      label: '점수',
                      backgroundColor: `rgba(${hexToRgb(dangerColor[0])}, 1)`,
                      barThickness: 10,
                      borderColor: dangerColor[0],
                      borderWidth: 1,
                      hoverBackgroundColor: `rgba(${hexToRgb(dangerColor[0])}, 0.4)`,
                      hoverBorderColor: dangerColor[0],
                      data: nq
                    },
                    {
                      label: '평균',
                      backgroundColor: `rgba(${hexToRgb(grayColor[0])}, 0.8)`,
                      barThickness: 10,
                      borderColor: grayColor[0],
                      borderWidth: 1,
                      hoverBackgroundColor: `rgba(${hexToRgb(grayColor[0])}, 0.4)`,
                      hoverBorderColor: grayColor[0],
                      data: avgNQ
                    }
                  ]
                }}
                // width={300}
                // height={150}
                options={{
                  // maintainAspectRatio: false,
                  layout: {
                    // padding: {
                    //   left: 150,
                    //   right: 150,
                    //   top: 50,
                    //   bottom: 50,
                    // }
                  },
                  scales: {
                    yAxes: [
                      {
                        gridLines: {
                          color: 'rgba(255, 255, 255, 0.4)',
                          borderDash: [1, 3],
                        },
                      },
                    ],
                    xAxes: [
                      {
                        gridLines: {
                          color: '#aaa',
                          borderDash: [1, 3],
                        },
                      },
                    ],
                  },
                }}
                legend={{ display: false }}
              />
              {
                _.sum(nq) === 0
                  ? <NotEnoughData />
                  : null
              }
            </CardSection>
          </Col>
        </Row>
        <Row className='mb-3'>
          <Col>
            <CardSection
              classes={classes}
              title={'엔브레인 - 캘린더'}
              titleImage={enbrainWhiteLogo}
            >
              <div className='border'>
                <BigCalendar
                  selectable
                  localizer={localizer}
                  views={['month']}
                  events={events}
                  defaultView="month"
                  scrollToTime={new Date(2020, 1, 1, 6)}
                  defaultDate={new Date()}
                // onSelectEvent={event => this.selectedEvent(event)}
                // onSelectSlot={slotInfo => this.addNewEventAlert(slotInfo)}
                // eventPropGetter={this.eventColors}
                />
              </div>
              {
                events.length === 0
                  ? <NotEnoughData />
                  : null
              }
            </CardSection>
          </Col>
          <Col>
            <CardSection
              classes={classes}
              title={'엔브레인 - 일별 상세 기록'}
              titleImage={enbrainWhiteLogo}
              legends={[
                { className: 'legendInfoBox', title: '점수' },
                { className: 'legendDangerBox', title: '평균' },
              ]}
            >
              <Line
                data={enbrainPlayTimesData}
              />
              {
                _.sum(enbrainResult.map(item => item.count)) === 0
                  ? <NotEnoughData />
                  : null
              }

            </CardSection>
          </Col>
        </Row>
        <Row className='mb-3'>
          <Col>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div style={{
                backgroundColor: infoColor[0],
                borderRadius: 10,
                width: 20,
                height: 20,
                marginRight: "8px",
                marginBottom: "16px",
              }}></div><span style={{ fontSize: '1.5em', fontWeight: 'bold' }}>정신건강테스트 - 치매 / 우울증 / 스트레스 검사결과</span>
            </div>
          </Col>
        </Row>
        <Row className='mb-3'>
          <Col>
            <CardSection
              classes={classes}
              headerColor={'info'}
              title={'정신건강테스트 - 치매(MMSE-K)'}
              titleImage={enbrainWhiteLogo}
              legends={[
                { className: 'legendInfoBox', title: '점수' },
                { className: 'legendDangerBox', title: '평균' },
              ]}
            >
              <Line data={() => testResultData('디멘시아')} />
              {
                testResult
                  .filter(item => item.game_id === '디멘시아')
                  .length === 0
                  ? <NotEnoughData />
                  : null
              }
            </CardSection>
          </Col>
          <Col>
            <CardSection
              classes={classes}
              headerColor={'info'}
              title={'정신건강테스트 - 우울증'}
              titleImage={enbrainWhiteLogo}
              legends={[
                { className: 'legendInfoBox', title: '점수' },
                { className: 'legendDangerBox', title: '평균' },
              ]}
            >
              <Line data={() => testResultData('우울증')} />
              {
                testResult
                  .filter(item => item.game_id === '우울증')
                  .length === 0
                  ? <NotEnoughData />
                  : null
              }
            </CardSection>
          </Col>
        </Row>
        <Row>
          <Col>
            <CardSection
              classes={classes}
              headerColor={'info'}
              title={'정신건강테스트 - 스트레스'}
              titleImage={enbrainWhiteLogo}
              legends={[
                { className: 'legendInfoBox', title: '점수' },
                { className: 'legendDangerBox', title: '평균' },
              ]}
            >
              <Line data={() => testResultData('스트레스')} legend={null} />
              {
                testResult
                  .filter(item => item.game_id === '스트레스')
                  .length === 0
                  ? <NotEnoughData />
                  : null
              }
            </CardSection>
          </Col>
          <Col>
          </Col>
        </Row>
      </Container>
    )
    : null
}

DashboardForPerson.propTypes = {
  uid: PropTypes.string,
  org_id: PropTypes.string,
};

export default DashboardForPerson;